// extracted by mini-css-extract-plugin
export default {"nameCellRootWrapper":"UserTable_nameCellRootWrapper__0yaxo"};